import { Component, Inject, Input } from '@angular/core';

import { FieldOkItemComponent } from '@softline/dynamic';

@Component({
  selector: 'soft-field-ok-zahlartkassa-data-view',
  imports: [],
  templateUrl: './zahlartkassa.list-view.html',
  styleUrls: ['./zahlartkassa.list-view.css'],
})
export class ZahlartkassaListView implements FieldOkItemComponent<any> {
  @Input() item: any;

  constructor() {}
}
